import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";

export default function TabComp({
     tabs, 
    contents, 
    initialValue = 0,   
    indicatorBackgroundColor,
    TextColor,
    SelectedTextColor,
    HoverTextColor,
    onChange
}) {
  const [value, setValue] = useState(initialValue);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    onChange && onChange(newValue);
  };


  return (
    <Box sx={{ width: "100%",  }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", marginLeft: "24px" }}>
        <Tabs
          textColor="inherit"
          indicatorColor="primary"
          value={value}
          onChange={handleChange || onChange}
          sx={{
            '.MuiTabs-indicator': {
              backgroundColor: indicatorBackgroundColor,
              height : "3px"
            },
            '.MuiTab-root': {
              color:    TextColor,
              fontSize: '14px',
              fontWeight: 400,
              '&.Mui-selected': {
                fontWeight: 600,
                color: SelectedTextColor,
              },
              '&:hover': {
                color:     HoverTextColor,
              },
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab key={index} label={tab} />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ p: 3 }}>
        {contents.map((content, index) => (
          <div key={index} hidden={value !== index}>
            {value === index && content}
          </div>
        ))}
      </Box>
    </Box>
  );
}

TabComp.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  contents: PropTypes.arrayOf(PropTypes.node).isRequired,
  initialValue: PropTypes.number,
};
